import axios from 'axios'
import { addAuthInterceptor, addErrorInterceptor } from './factory/AxiosInterceptors';

const kpiApi = axios.create({
  baseURL: process.env.BASE_URL + 'api/kpi',
  timeout: 10000
});

addAuthInterceptor(kpiApi);
addErrorInterceptor(kpiApi,
  // Default error payload
  { kpiCodes: [], kpiGroupCodes: [] }
);

export default {
  baseURL: process.env.BASE_URL + 'api/kpi',

  async getSearchOptions(clientId, currentLocale, mode) {
    const payload = { clientId, mode, localizationId: currentLocale };
    const response = await kpiApi.post('/search-options', payload);
    return response.data;
  },

  async getDetails(clientId, currentLocale, kpi) {
    const payload = { kpiCode: kpi.label, type: kpi.type, clientId, localizationId: currentLocale };
    const response = await kpiApi.post('/details', payload);
    return response.data;
  },

  async getPageDetails(clientId, pageName, currentLocale) {
    const payload = { clientId: clientId, page: pageName, localizationId: currentLocale };
    const response = await kpiApi.post('/read-page-details', payload);
    return response.data;
  }
};


// USE [MSMReporting_BMW]
// GO
// /****** Object:  StoredProcedure [REP].[AAA_GetKpiNames]    Script Date: 14.11.2025 13:41:04 ******/
// SET ANSI_NULLS ON
// GO
// SET QUOTED_IDENTIFIER ON
// GO
// ALTER PROCEDURE [REP].[AAA_GetKpiNames]
//     @ClientId INT,
//     @LocalizationId NVARCHAR(50) = N'deflt'
// AS
// BEGIN
// SET NOCOUNT ON;
//     SELECT DISTINCT KpiCode FROM REP.SurveyKpi AS K
//     WHERE K.SurveyId
//         in (SELECT SurveyId FROM REP.Survey AS SIDS
//             WHERE ClientId=@ClientId)
//     SELECT DISTINCT KpiGroupCode FROM REP.SurveyKpiGroup KG
//     WHERE KG.SurveyId
//         in (SELECT SurveyId FROM REP.Survey AS SIDS
//             WHERE ClientId=@ClientId)
// END
